<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'Withdrawal',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/withdraw/make', label: 'Withdraw' }
      ]
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/withdrawal/Withdrawal.Entry.vue